import { Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "../contexts/LocaleContext";

export default function CheckoutCancelPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { localizePath } = useLocale();

  return (
    <Container maxWidth="sm" sx={{ py: 6, textAlign: "center" }}>
      <Typography variant="h5" gutterBottom>
        {t("checkoutCancel.title")}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        {t("checkoutCancel.desc")}
      </Typography>
      <Button variant="contained" onClick={() => navigate(localizePath("/checkout"))} sx={{ mr: 2 }}>
        {t("checkoutCancel.tryAgain")}
      </Button>
      <Button onClick={() => navigate(localizePath("/"))}>
        {t("checkoutCancel.goToDashboard")}
      </Button>
    </Container>
  );
}
